<template>
  <button
    :class="[
      'relative inline-flex shadow-md hover:border-orange-500 border border-transparent hover:text-orange-500 items-center justify-center size-6.5 rounded-lg text-sm font-semibold transition-colors focus:z-20 focus:outline-offset-0',
      {
        'bg-orange-500 !text-white ': isActive,
        'bg-white text-gray-600 ': !isActive,
        'opacity-50 cursor-not-allowed': disabled,
      },
    ]"
    :disabled="disabled"
    :title="title"
    @click="$emit('click')"
  >
    <span v-if="srText" class="sr-only">{{ srText }}</span>
    <component :is="icon" v-if="icon" class="size-5" aria-hidden="true" />
    <template v-else>{{ content }}</template>
  </button>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

defineProps<{
  content?: string | number
  icon?: Component
  isActive?: boolean
  disabled?: boolean
  title?: string
  srText?: string
}>()

defineEmits<{
  click: []
}>()
</script>
